import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta({
    title: "页面不存在 - 日本情色电影",
    description: "你访问的页面不存在或已被移动。可以返回首页，继续浏览日本情色电影的影片档案与资讯。",
    keywords: "页面不存在,日本情色电影",
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-24">
        <div className="w-full max-w-xl text-center">
          <p className="font-display text-[92px] leading-none text-primary-700/60">404</p>
          <h1 className="mt-4 font-heading text-xl font-bold text-foreground-50 md:text-2xl">
            这个页面不存在
          </h1>
          <p className="mt-3 text-[12px] text-foreground-600 font-label">{location.pathname}</p>
          <p className="mt-4 text-[13px] leading-relaxed text-foreground-400">
            链接可能已失效或输入有误。你可以回到首页，从焦点影片或分类入口继续浏览。
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-[13px] text-foreground-50 transition-colors hover:bg-primary-600 font-label"
            >
              返回首页
            </Link>
            <Link
              to="/news"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300/80 px-5 py-2.5 text-[13px] text-foreground-200 transition-colors hover:border-accent-500 hover:text-accent-400 font-label"
            >
              浏览资讯
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}